<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm" class="reset-form-inline">
          <!-- <el-form-item label="交易账户">
            <template slot="label">
              <I18Lang id="user39" defaultText="交易账户" />
            </template>
            <el-select v-model="queryForm.trade_account_mode" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in transferAccountTypes" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="转账时间">
            <template slot="label">
              <I18Lang id="my70" defaultText="转账时间" />
            </template>
            <el-date-picker v-model="queryDate" type="daterange" @change="dateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>
        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>
          <el-table-column label="转账金额($)" prop="amount">
            <template slot="header">
              <I18Lang id="public71" defaultText="转账金额($)" />
            </template>
          </el-table-column>
          <!--
          <el-table-column :label="`${$t('my51', { n: currMarket })}`" prop="amount_local">
          </el-table-column>
          <el-table-column label="转账汇率" prop="exchange_rate">
            <template slot="header">
              <I18Lang id="userstatement68" defaultText="转账汇率" />
            </template>
          </el-table-column>

          <el-table-column label="交易账户">
            <template slot="header">
              <I18Lang id="user39" defaultText="交易账户" />
            </template>
            <template slot-scope="scope">
              {{ transferAccountTypes[scope.row.trade_account_mode] }}
            </template>
          </el-table-column> -->
          <el-table-column label="交易账户">
            <template slot="header">
              <I18Lang id="public72" defaultText="交易账户" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.trade_account_no }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('userstatement70')}（MEQ）`" prop="trade_account_balance">
          </el-table-column>
          <el-table-column label="说明" prop="transfer_type">
            <template slot-scope="scope">
             {{transferTypeOptions[scope.row.transfer_type]}}
            </template>
          </el-table-column>
          <el-table-column label="转账时间" prop="create_time">
            <template slot="header">
              <I18Lang id="my70" defaultText="转账时间" />
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import { transferAccountTypes, auditStatusList } from '@utils/global'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      transferAccountTypes,
      queryDate: '',
      transferTypeOptions: {
        1: '转入交易账户',
        2: '转出至现金账户'
      },
      queryForm: {
        trade_account_mode: '',
        start_time: '',
        end_time: '',
        page: '',
        size: ''
      },
      statusList: auditStatusList,
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    getRecord () {
      this.$http
        .post('/api/cash/tradeTransferRecords', this.queryForm)
        .then((result) => {
          this.tableData = result
        })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss"></style>
